import { Segmented } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Фильтр по статусу.
 *
 * Умолчание — `pending`, а не «все»: оператор открывает раздел ради очереди, и
 * показывать ему сначала месяц обработанных заявок, среди которых надо найти
 * две новые, — значит заставлять его каждый раз щёлкать фильтр.
 *
 * Обобщён по типу статуса ради очереди модерации отзывов (доработки §6.2): у
 * неё свой набор (`flagged`, `pending`, `published`, `hidden`), но подписи
 * берутся из того же словаря `status.*`, и второй такой же виджет отличался бы
 * от этого только именем типа.
 *
 * Пустой массив означает «все»: и заявки, и отзывы понимают его одинаково —
 * бэкенд без фильтра отдаёт свою разумную выборку.
 */
export function StatusFilter<T extends string>({
  value,
  onChange,
  statuses,
}: {
  value: T[];
  onChange: (next: T[]) => void;
  statuses: readonly T[];
}) {
  const { t } = useTranslation();
  const current = value.length === 1 ? value[0] : "all";

  return (
    <Segmented
      value={current}
      onChange={(next) => {
        onChange(next === "all" ? [] : [next as T]);
      }}
      options={[
        ...statuses.map((status) => ({ value: status, label: t(`status.${status}`) })),
        { value: "all", label: t("users.filterAll") },
      ]}
    />
  );
}
